import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ParameterConfig } from './parameter-config';

@Metamodel.model({})
export class ParameterConfigString extends ParameterConfig {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    // overwrite to specialize expression type
    @Metamodel.attribute({
        templatable: true,
        accepts: ['String'],
        association: 'VALUE'
    })
    public value: string = '';
}
